import { Button } from "@/components/Button";
import { useState } from "react";
import {
    CheckIcon,
    UserIcon,
    PlayCircleIcon,
    ClipboardDocumentListIcon,
    ChatBubbleLeftRightIcon,
    AcademicCapIcon,
    CalendarDaysIcon,
    ClockIcon,
    UsersIcon,
} from "@heroicons/react/24/solid";

export const gradientGreen = "bg-[#00bf63]";


const Standard: React.FC = () => {
    const [expandedFAQ, setExpandedFAQ] = useState<number | null>(null);

    // Cores base da identidade visual (mantidas aqui para referência futura)

    const scrollToPricing = () => {
        const pricingSection = document.getElementById('pricing-section');
        if (pricingSection) {
            pricingSection.scrollIntoView({ behavior: 'smooth' });
        }
    };



    return (
        <div className="w-full">
            {/* Hero Section */}
            <section className="w-full bg-[#0e0352]">
                <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 items-center gap-6 lg:gap-10 px-4 sm:px-6 lg:px-8 py-8 sm:py-12 lg:py-20">
                    {/* Left: Logos + Copy + CTA */}
                    <div className="text-center lg:text-left">
                        {/* Logos row (placeholders) */}
                        <div className="flex flex-row items-center justify-center lg:justify-start gap-4 sm:gap-6 mb-4">
                            <img src="https://teraquiz.s3.us-east-005.backblazeb2.com/teraquiz/image_1757504780516295815_68c1650c.webp" alt="Logo parceiro" className="h-10 sm:h-12 md:h-14 lg:h-16 w-auto object-contain" />
                            <img src="https://teraquiz.s3.us-east-005.backblazeb2.com/teraquiz/image_1757504800050046681_68c16520.webp" alt="Logo Teraquiz" className="h-10 sm:h-12 md:h-14 lg:h-16 w-auto object-contain" />
                        </div>
                        <h1 className="text-white font-bold leading-tight text-3xl sm:text-4xl lg:text-[44px] lg:leading-[1.1] mb-5">
                            Lançamento
                            <br />
                            Curso Finanças
                            <br />
                            para Médicos
                        </h1>

                        <p className="text-gray-200 text-base sm:text-lg leading-relaxed max-w-xl mx-auto lg:mx-0 mb-7">
                            O curso completo para médicos que querem parar de trocar tempo por dinheiro e começar a construir liberdade financeira.
                        </p>

                        <button
                            onClick={scrollToPricing}
                            className={`
                                w-full sm:w-auto bg-white text-[17px] font-semibold py-3 px-12 rounded-[12px]
                        `}
                        >
                            Quero minha liberdade financeira
                        </button>
                    </div>

                    {/* Right: Smaller image — centered on mobile, right on desktop */}
                    <div className="relative flex justify-center lg:justify-end">
                        <img
                            src="https://teraquiz.s3.us-east-005.backblazeb2.com/teraquiz/image_1757504813904054725_68c1652d.webp"
                            alt="Colocar imagem do herói aqui"
                            className="w-[240px] h-[280px] sm:w-[280px] sm:h-[320px] md:w-[300px] md:h-[340px] object-cover rounded-2xl shadow-xl"
                        />
                    </div>
                </div>
            </section>

            {/* Problem Section */}
            <section className="w-full bg-white">
                <div className="max-w-6xl mx-auto px-6 lg:px-8 py-12 lg:py-16">
                    {/* Title with red X */}
                    <div className="flex items-start justify-center gap-3 mb-6">
                        <h2 className="text-2xl sm:text-3xl font-extrabold text-[#08082f] text-center">
                            <span className="text-[32px]">❌</span>  Você estudou tudo sobre
                            <span className="block">medicina...</span>
                        </h2>
                    </div>

                    <p className="text-gray-700 text-base sm:text-lg leading-relaxed text-center max-w-3xl mx-auto mb-10">
                        Mas ninguém te ensinou o que fazer com o dinheiro e como investir para ter uma renda passiva. Afinal, <strong> isso sim vai te garantir tranquilidade, principalmente nestes tempos de instabilidade
                            no mercado médico</strong> (picaretas, plantões pagando menos, convênios pressionando preços... e você no meio disso tudo).
                    </p>

                    {/* Cards */}
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
                        <div className="bg-teal-50 border border-teal-100 rounded-2xl p-6">
                            <div className="flex items-start gap-3">
                                <div className="mt-0.5 rounded-md bg-green-500 p-1.5">
                                    <CheckIcon className="w-5 h-5 text-white" />
                                </div>
                                <p className="text-[#0b3b2e] font-semibold leading-snug">
                                    Ainda não entende sobre investimentos ou um plano claro de futfinance
                                </p>
                            </div>
                        </div>

                        <div className="bg-teal-50 border border-teal-100 rounded-2xl p-6">
                            <div className="flex items-start gap-3">
                                <div className="mt-0.5 rounded-md bg-green-500 p-1.5">
                                    <CheckIcon className="w-5 h-5 text-white" />
                                </div>
                                <p className="text-[#0b3b2e] font-semibold leading-snug">
                                    Não sabe criar sua reserva de emergência
                                </p>
                            </div>
                        </div>

                        <div className="bg-teal-50 border border-teal-100 rounded-2xl p-6">
                            <div className="flex items-start gap-3">
                                <div className="mt-0.5 rounded-md bg-green-500 p-1.5">
                                    <CheckIcon className="w-5 h-5 text-white" />
                                </div>
                                <p className="text-[#0b3b2e] font-semibold leading-snug">
                                    Não sabe opinar ou analisar os investimentos que seu gestor te
                                    <span className="line-through mx-1">entuba</span>
                                    sugere
                                </p>
                            </div>
                        </div>
                    </div>

                    <p className="text-center text-2xl sm:text-3xl font-extrabold text-[#08082f]">
                        Então, esse curso é pra você
                    </p>
                </div>
            </section>

            {/* Steps Section */}
            <section className="w-full bg-[#ecf7f9]">
                <div className="max-w-6xl mx-auto px-6 lg:px-8 py-12 lg:py-16 relative">
                    <h3 className="text-center text-[#08082f] font-extrabold text-xl sm:text-2xl mb-10">
                        4 ETAPAS PARA VOCÊ CONSEGUIR
                        <br className="hidden sm:block" />
                        APLICAR SEU DINHEIRO:
                    </h3>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                        {/* Etapa 01 */}
                        <div className="bg-white rounded-2xl border-2 border-indigo-300 p-6 sm:p-8 shadow-sm">
                            <span className="inline-block bg-indigo-600 text-white text-sm font-extrabold tracking-wider px-4 py-1 rounded-md mb-4">
                                ETAPA 01
                            </span>
                            <h4 className="text-[#08082f] font-extrabold text-lg sm:text-xl mb-3">
                                Fundamentos de finanças e economia para entender a base de funcionamento dos investimentos.
                            </h4>
                            <p className="text-gray-700 leading-relaxed text-sm sm:text-base">
                                Aqui, você irá dar o primeiro passo para conhecer o mercado financeiro. Você vai conhecer a base de economia e entender como a Taxa Selic e inflação impactam os preços dos ativos. Além disso, vai aprender o tal falado Tripé de Investimentos que é fundamental para uma boa escolha de investimento
                            </p>
                        </div>

                        {/* Etapa 02 */}
                        <div className="bg-white rounded-2xl border-2 border-indigo-300 p-6 sm:p-8 shadow-sm">
                            <span className="inline-block bg-indigo-600 text-white text-sm font-extrabold tracking-wider px-4 py-1 rounded-md mb-4">
                                ETAPA 02
                            </span>
                            <h4 className="text-[#08082f] font-extrabold text-lg sm:text-xl mb-3">
                                Principais opções de investimentos de renda fixa do mercado brasileiro.
                            </h4>
                            <p className="text-gray-700 leading-relaxed text-sm sm:text-base">
                                Nessa etapa você irá entrar a fundo em cada um dos principais produtos de renda fixa do Brasil como CDB, LCI, LCA, Títulos Públicos, CRI, CRA e Debêntures. Vai entender como analisar o risco de cada um desses investimentos e como calcular sua rentabilidade líquida após desconto de imposto. E claro, vai conseguir entender na prática qual produto será mais adequado para sua carteira de investimentos.
                            </p>
                        </div>

                        {/* Etapa 03 */}
                        <div className="bg-white rounded-2xl border-2 border-indigo-300 p-6 sm:p-8 shadow-sm">
                            <span className="inline-block bg-indigo-600 text-white text-sm font-extrabold tracking-wider px-4 py-1 rounded-md mb-4">
                                ETAPA 03
                            </span>
                            <h4 className="text-[#08082f] font-extrabold text-lg sm:text-xl mb-3">
                                Principais opções de investimentos de renda variável.
                            </h4>
                            <p className="text-gray-700 leading-relaxed text-sm sm:text-base">
                                Depois da renda fixa, vamos mergulhar no universo da renda variável: ações, fundos imobiliários, ETFs e BDRs. Você entenderá como investir nesses ativos, o que é uma empresa de qualidade, como se avalia seu valor e quais estratégias podem trazer retorno — sempre considerando o seu perfil de risco.
                            </p>
                        </div>

                        {/* Etapa 04 */}
                        <div className="bg-white rounded-2xl border-2 border-indigo-300 p-6 sm:p-8 shadow-sm">
                            <span className="inline-block text-indigo-700 border-2 border-indigo-700 text-sm font-extrabold tracking-wider px-4 py-1 rounded-md mb-4">
                                ETAPA 04
                            </span>
                            <h4 className="text-[#08082f] font-extrabold text-lg sm:text-xl mb-3">
                                Pilares fundamentais para montar sua carteira de investimentos
                            </h4>
                            <p className="text-gray-700 leading-relaxed text-sm sm:text-base">
                                E para fechar o programa na última etapa você vai entender como montar sua carteira de investimentos: o que precisa avaliar para conseguir escolher os ativos que sejam adequados com a sua estratégia.
                            </p>
                        </div>
                    </div>

                    {/* Central decorative placeholder (porquinho) */}
                    <div className="hidden md:flex absolute inset-0 pointer-events-none items-center justify-center">
                        <div className="w-28 h-28 md:w-32 md:h-32 rounded-full flex items-center justify-center shadow-lg border-4 border-white bg-white/70">
                            <img src="https://teraquiz.s3.us-east-005.backblazeb2.com/teraquiz/image_1757505460802731862_68c167b4.webp" alt="Ícone decorativo" className="h-20 md:h-24 object-contain" />
                        </div>
                    </div>
                </div>
            </section>

            {/* Instructor Section */}
            <section className="w-full bg-[#08082f]">
                <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-10 sm:py-12 lg:py-16 grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 items-center">
                    {/* Foto da instrutora */}
                    <div className="relative w-full max-w-[440px] h-[420px] sm:h-[360px] md:h-[420px] order-1 md:order-none">
                        <div className="rounded-2xl overflow-hidden shadow-2xl border border-indigo-300 h-full">
                            <img src="https://teraquiz.s3.us-east-005.backblazeb2.com/teraquiz/image_1757505678122055625_68c1688e.webp" alt="Foto da instrutora" className="w-full h-full object-cover object-top" />
                        </div>
                        {/* Medalha decorativa */}
                        <div className="hidden sm:block absolute -bottom-4 right-4 md:-bottom-6 md:right-1">
                            <img src="https://teraquiz.s3.us-east-005.backblazeb2.com/teraquiz/image_1757505919879017745_68c1697f.webp" alt="Selo" className="w-16 h-16 md:w-20 md:h-20 object-contain" />
                        </div>
                    </div>

                    {/* Texto */}
                    <div className="bg-white rounded-2xl p-6 sm:p-8 shadow-lg">
                        <h3 className="text-xl sm:text-2xl font-extrabold text-[#08082f] uppercase tracking-wide mb-3">
                            COM QUEM VOCÊ VAI <span className="text-[#2ad1b0]">APRENDER</span>
                        </h3>
                        <p className="text-[#08082f] font-extrabold text-lg sm:text-xl mb-2">Luciana Ballesteros</p>
                        <p className="text-gray-700 leading-relaxed text-sm sm:text-base">
                            Com mais de 20 anos de experiência na área Financeira, Luciana é graduada em Administração de Empresas pelo IBMEC, pós-graduada em Finanças pela Fundação Dom Cabral e com uma especialização em Finanças pela Berkeley - University of California. Acreditando no poder transformador do conhecimento por meio da educação financeira, fundou a Financial Experts e vem formando centenas de alunos.
                        </p>
                    </div>
                </div>
            </section>

            {/* Benefits Section */}
            <section className="w-full bg-white">
                <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-10 sm:py-12 lg:py-16">
                    <h3 className="text-center text-[#24bfa0] font-extrabold text-xl sm:text-2xl mb-8">
                        O QUE VOCÊ VAI TER ACESSO:
                    </h3>

                    <div className="bg-white rounded-2xl p-2 sm:p-4">
                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
                            {/* Item 1 */}
                            <div className="bg-[#0f1442] text-white rounded-xl p-4 flex items-start gap-3 border border-[#2a2f67]">
                                <UserIcon className="w-6 h-6 text-white mt-0.5" />
                                <span className="font-semibold">Acompanhamento individualizado</span>
                            </div>
                            {/* Item 2 */}
                            <div className="bg-[#0f1442] text-white rounded-xl p-4 flex items-start gap-3 border border-[#2a2f67]">
                                <PlayCircleIcon className="w-6 h-6 text-white mt-0.5" />
                                <span className="font-semibold">48 aulas gravadas.</span>
                            </div>
                            {/* Item 3 */}
                            <div className="bg-[#0f1442] text-white rounded-xl p-4 flex items-start gap-3 border border-[#2a2f67]">
                                <ClipboardDocumentListIcon className="w-6 h-6 text-white mt-0.5" />
                                <span className="font-semibold">Quiz Finanças.</span>
                            </div>
                            {/* Item 4 */}
                            <div className="bg-[#0f1442] text-white rounded-xl p-4 flex items-start gap-3 border border-[#2a2f67]">
                                <ChatBubbleLeftRightIcon className="w-6 h-6 text-white mt-0.5" />
                                <span className="font-semibold">Linguagem acessível.</span>
                            </div>
                            {/* Item 5 */}
                            <div className="bg-[#0f1442] text-white rounded-xl p-4 flex items-start gap-3 border border-[#2a2f67]">
                                <AcademicCapIcon className="w-6 h-6 text-white mt-0.5" />
                                <span className="font-semibold">Certificado de conclusão.</span>
                            </div>
                            {/* Item 6 */}
                            <div className="bg-[#0f1442] text-white rounded-xl p-4 flex items-start gap-3 border border-[#2a2f67]">
                                <CalendarDaysIcon className="w-6 h-6 text-white mt-0.5" />
                                <span className="font-semibold">1 ano de acesso à plataforma.</span>
                            </div>
                            {/* Item 7 */}
                            <div className="bg-[#0f1442] text-white rounded-xl p-4 flex items-start gap-3 border border-[#2a2f67]">
                                <ClockIcon className="w-6 h-6 text-white mt-0.5" />
                                <span className="font-semibold">Cronograma detalhado para acompanhamento das aulas.</span>
                            </div>
                            {/* Item 8 */}
                            <div className="bg-[#0f1442] text-white rounded-xl p-4 flex items-start gap-3 border border-[#2a2f67]">
                                <UsersIcon className="w-6 h-6 text-white mt-0.5" />
                                <span className="font-semibold">Grupo de WhatsApp exclusivo para dúvidas e networking.</span>
                            </div>
                        </div>
                    </div>

                    <div className="mt-8 text-center">
                        <Button onClick={scrollToPricing} className="w-full sm:w-auto">Quero minha liberdade financeira</Button>
                    </div>
                </div>
            </section>

            {/* Pricing Section */}
            <section id="pricing-section" className="w-full bg-[#08082f]">
                <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-10 sm:py-12 lg:py-16">
                    {/* Card de preço */}
                    <div className="relative bg-[#bdf5d8] rounded-2xl p-8 shadow-2xl border-4 border-white/70">
                        <h3 className="text-center text-[#0b1443] font-extrabold text-xl tracking-wide mb-4 uppercase">
                            INVESTIMENTO:
                        </h3>
                        <p className="text-center text-[#0b1443] font-bold line-through mb-3">
                            De R$2179,90
                        </p>
                        <div className="flex justify-center mb-4">
                            <div className="bg-[#22c55e] text-white font-extrabold text-base sm:text-xl px-4 sm:px-5 py-3 rounded-lg shadow">
                                Por R$1800 à vista
                            </div>
                        </div>
                        <p className="text-center text-[#0b1443] font-semibold mb-2">
                            em até 12x
                        </p>
                        <p className="text-center italic text-[#ff5a3c] font-semibold">
                            ✱Condição especial de lançamento com duração de 24 horas!
                        </p>
                    </div>

                    {/* Garantia */}
                    <div className="text-center mt-10">
                        <p className="text-white font-extrabold uppercase tracking-wide mb-2">
                            🎯 GARANTIA INCONDICIONAL DE 7 DIAS
                        </p>
                        <p className="text-white/90 max-w-2xl mx-auto">
                            Teste o curso por 7 dias. Se você não gostar, basta pedir reembolso. Simples assim. Zero risco.
                        </p>
                    </div>

                    {/* CTA */}
                    <div className="text-center mt-8">
                        <Button onClick={() => window.open('https://teraquiz.com/asaas?id=curso-financas-para-medicos', '_blank')} className="w-full sm:w-auto">
                            Quero fazer parte do Finanças para Médicos
                        </Button>
                    </div>
                </div>
            </section>

            {/* FAQ Section */}
            <section className="w-full bg-white">
                <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 py-10 sm:py-12 lg:py-16">
                    <h3 className="text-center text-[#08082f] font-extrabold tracking-wide mb-6 uppercase">
                        PERGUNTAS FREQUENTES
                    </h3>

                    <div className="space-y-4">
                        {[
                            { t: '"Esse curso realmente vai me ajudar, mesmo eu sendo médico e sem tempo pra nada?"', r: 'Sim! O curso é prático, direto ao ponto e você encaixa na rotina, podendo ouvir no carro, na academia, na forma de podcast... pelo celular, tablet ou computador!', emoji: '✨', color: 'green' },
                            { t: '"Eu já ganho bem... por que eu deveria investir em um curso de finanças?"', r: 'Nada pode ser melhor que poder escolher trabalhar menos por ter feito boas escolhas de investimento, com uma renda passiva que permite que o dinheiro trabalhe por você.', emoji: '✨', color: 'blue' },
                            { t: '"Não entendo nada de finanças. Vou conseguir acompanhar?"', r: 'Sim! o curso é voltado para quem não teve nenhuma exposição, com didática de alguém expert no assunto (e expert em educação)!', emoji: '✨', color: 'green' },
                            { t: '"Tem risco de eu comprar e me arrepender?"', r: 'Não! Oferecemos garantia incondicional de 7 dias. Se por qualquer motivo você não ficar satisfeito, devolvemos 100% do seu dinheiro.', emoji: '✨', color: 'blue' },
                            { t: '"Qual o diferencial desse curso em relação a outros de finanças?"', r: 'Esse curso é focado e prático, encaixa na sua rotina e vai te permitir entender e investir o seu dinheiro de forma consciente.', emoji: '✨', color: 'green' },
                            { t: '"E se eu tiver dúvidas durante o curso?"', r: 'Todas as dúvidas podem ser enviadas pelo grupo de WhatsApp e serão respondidas pela Lu, expert no assunto e professora!', emoji: '✨', color: 'blue' },
                            { t: '"Tem alguma vantagem para quem se inscrever agora?"', r: 'Sim! Quem se inscrever hoje garante o menor preço possível + acesso ao grupo exclusivo de WhatsApp com a professora + bônus especiais que não estarão disponíveis depois!', emoji: '✨', color: 'green' },
                            { t: '📌 "Por quanto tempo terei acesso ao curso?"', r: 'O curso fica disponível por 12 meses.', emoji: '', color: 'blue' },
                            { t: '📌 "Por onde terei acesso ao curso?"', r: 'O acesso fica dentro do aplicativo Teraquiz, na área de vídeos do Tera Academy.', emoji: '', color: 'green' },
                        ].map((item, idx) => (
                            <div key={idx} className="w-full">
                                <button
                                    onClick={() => setExpandedFAQ(expandedFAQ === idx ? null : idx)}
                                    className={`w-full text-left rounded-2xl px-4 sm:px-5 py-4 flex items-center justify-between gap-4 shadow-md transition-all duration-300 hover:-translate-y-0.5 
                                        ${item.color === 'green' ? 'bg-[#00bf63] text-white' : 'bg-[#0f1442] text-white'}`}
                                >
                                    <span className="flex-1">
                                        {item.t}
                                    </span>
                                    <span className={`text-white/90 text-xl transition-transform duration-300 ${expandedFAQ === idx ? 'rotate-90' : ''}`}>
                                        »
                                    </span>
                                </button>
                                {expandedFAQ === idx && item.r && (
                                    <div className={`mt-2 mx-4 sm:mx-5 p-4 rounded-xl transition-all duration-300 ${item.color === 'green' ? 'bg-[#1a9b7a] text-white border border-[#23c6a6]' : 'bg-[#0a0f35] text-white border border-[#1e2a5e]'}`}>
                                        {item.r}
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Important CTA Section */}
            <section className="w-full bg-[#08082f]">
                <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-10 sm:py-12 lg:py-16 text-center">
                    <h3 className="text-white font-extrabold uppercase tracking-wide text-lg mb-3">
                        IMPORTANTE <span className="text-red-500">❗</span>
                    </h3>
                    <p className="text-white/90 text-lg mb-7">
                        O preço de lançamento fica disponível por 24 horas.
                    </p>

                    <div className="flex justify-center mb-10">
                        <button
                            onClick={() => window.open('https://teraquiz.com/asaas?id=curso-financas-para-medicos', '_blank')}
                            className="bg-[#c7f5ea] text-[#0b1443] font-semibold px-6 py-3 rounded-full shadow-sm hover:brightness-110 active:scale-95 transition w-full sm:w-auto"
                        >
                            Quero aproveitar as condições desta turma
                        </button>
                    </div>

                    <div className="flex flex-col items-center gap-6">
                        {/* Teraquiz brand */}
                        <div className="flex flex-row items-center gap-6 mb-4">
                            <img src="https://teraquiz.s3.us-east-005.backblazeb2.com/teraquiz/image_1757504780516295815_68c1650c.webp" alt="Logo parceiro" className="h-12 sm:h-16 object-contain" />
                            <img src="https://teraquiz.s3.us-east-005.backblazeb2.com/teraquiz/image_1757504800050046681_68c16520.webp" alt="Logo Teraquiz" className="h-12 sm:h-16 w-auto object-contain" />
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Standard;
